export { default } from './getInitialHoveredDate';